function removeClassesStartingWith(el, pattern)
{
    var toRemove = [];
    Array.from(el.classList).forEach(function(c)
    {
        if (c.indexOf(pattern) === 0)
        {
            toRemove.push(c);
        }
    });

    toRemove.forEach(function(c)
    {
        el.classList.remove(c);
    });
}

function scrollTo(el)
{
    if (el)
    {
        const rect = el.getBoundingClientRect();
        const targetY = rect.top + document.body.scrollTop - 20;

        $('html,body').animate({ scrollTop: targetY }, 300);
    }
}

function uuid()
{
    //http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
    var d = new Date().getTime();
    if (window.performance && typeof window.performance.now === "function")
    {
        d += performance.now(); //use high-precision timer if available
    }
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c)
    {
        var r = (d + Math.random()*16)%16 | 0;
        d = Math.floor(d/16);
        return (c=='x' ? r : (r&0x3|0x8)).toString(16);
    });
    return uuid;
}

function propertyByDotString(dotString, obj)
{
    return dotString.split('.').reduce(function(prev, curr)
    {
        return prev ? prev[curr] : undefined;
    }, obj || self);
}

function getAllUrlParams(url)
{

  // get query string from url (optional) or window
  var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

  // we'll store the parameters here
  var obj = {};

  // if query string exists
  if (queryString) {

    // stuff after # is not part of query string, so get rid of it
    queryString = queryString.split('#')[0];

    // split our query string into its component parts
    var arr = queryString.split('&');

    for (var i=0; i<arr.length; i++) {
      // separate the keys and the values
      var a = arr[i].split('=');

      // in case params look like: list[]=thing1&list[]=thing2
      var paramNum = undefined;
      var paramName = a[0].replace(/\[\d*\]/, function(v) {
        paramNum = v.slice(1,-1);
        return '';
      });

      // set parameter value (use 'true' if empty)
      var paramValue = typeof(a[1])==='undefined' ? true : a[1];

      // (optional) keep case consistent
      //paramName = paramName.toLowerCase();
      //paramValue = paramValue.toLowerCase();

      // if parameter name already exists
      if (obj[paramName]) {
        // convert value to array (if still string)
        if (typeof obj[paramName] === 'string') {
          obj[paramName] = [obj[paramName]];
        }
        // if no array index number specified...
        if (typeof paramNum === 'undefined') {
          // put the value on the end of the array
          obj[paramName].push(paramValue);
        }
        // if array index number specified...
        else {
          // put the value at that index number
          obj[paramName][paramNum] = paramValue;
        }
      }
      // if param name doesn't exist yet, set it
      else {
        obj[paramName] = paramValue;
      }
    }
  }

  return obj;
}


// https://medium.com/@_jh3y/throttling-and-debouncing-in-javascript-b01cad5c8edf
var debounce = function(func, delay)
{
    var inDebounce = undefined;
    return function()
    {
        var context = this, args = arguments;
        clearTimeout(inDebounce);
        return inDebounce = setTimeout(function()
        {
            return func.apply(context, args);
        }, delay);
    }
}
// https://medium.com/@_jh3y/throttling-and-debouncing-in-javascript-b01cad5c8edf
var throttle = function(func, limit)
{
    var inThrottle, lastFunc, throttleTimer;
    return function()
    {
        var context = this, args = arguments;
        if (inThrottle)
        {
            clearTimeout(lastFunc);
            return lastFunc = setTimeout(function()
            {
                func.apply(context, args);
                inThrottle = false;
            }, limit);
        }
        else
        {
            func.apply(context, args);
            inThrottle = true;
            return throttleTimer = setTimeout(function()
            {
                return inThrottle = false;
            }, limit);
        }
    };
};
